export const WEB_MODULES_INCIDENTS = "ec4433e7-1758-ea11-812f-000d3a19e5a7";
export const WEB_MODULES_WORKSHOP_INCIDENTS = "89447cf9-1758-ea11-812f-000d3a19e5a7";
export const WEB_MODULES_TICKETS = "5974c321-1858-ea11-812f-000d3a19e5a7";
export const WEB_MODULES_MAINTENANCE_CONTRACTS = "19474d2a-1858-ea11-812f-000d3a19e5a7";
export const WEB_MODULES_CONTRACTS = "e5dadf33-1858-ea11-812f-000d3a19e5a7";
export const WEB_MODULES_CLIENT_PRODUCTS = "1ab32f3c-1858-ea11-812f-000d3a19e5a7";
export const WEB_MODULES_INVOICES = "53a94b44-1858-ea11-812f-000d3a19e5a7";
export const WEB_MODULES_QUOTES = "56a94b44-1858-ea11-812f-000d3a19e5a7";
export const WEB_MODULES_OPPORTUNITIES = "62d7214b-1858-ea11-812f-000d3a19e5a7";
export const WEB_MODULES_CDT = "4d23745a-1858-ea11-812f-000d3a19e5a7";
export const WEB_MODULES_PROFILE = "1c05b365-1858-ea11-812f-000d3a19e5a7";
